module.exports = __webpack_public_path__ + "img/gratiaimage3.49a4c4be.jpg";